<template>
  <div :id="`question_${index + 1}`"
       class="flex"
  >
    <span class="w-12 py-2 px-4 text-3xl leading-relaxed absolute lg:w-20 lg:py-4 lg:px-6"
          :class="{
            'bg-exam-mark-correct': correct === 'correct',
            'bg-exam-mark-wrong': correct === 'wrong',
            'bg-exam-mark-part': correct === 'part',
          }"
    >{{ index + 1 }}</span>
    <div :class="[
      'min-w-0 py-3 flex-1 lg:pl-20 lg:py-5',
      [ isMobile ? 'pl-20' : 'pl-14' ],
    ]">
      <template>
        <div class="-ml-20 pl-20 flex items-center gap-x-1">
          <div v-if="isCreate || isCopy" class="handleQuestion w-10 h-10 my-5 bg-drag flex justify-center items-center absolute -left-5 box-content cursor-grab transform -translate-y-1"></div>
          <GrmTextField :placeholder="isMobile ? $t('testBank.alert.shortName') : $t('testBank.alert.name')" v-model="question.questionTitle" class="min-w-0 flex-1" :disabled="isView" />
          <div v-if="testbankObj.examType === 'QUIZ'" class="flex items-center gap-x-1">
            <GrmTextField type="number" placeholder="1" v-model="question.questionScore" class="w-20" :min="1" :max="100" :disabled="!isCreate && !isCopy" />
            <span class="text-xs">{{ $t('exam.question.point') }}</span>
          </div>
          <div v-if="isCreate || isCopy">
            <GrmBtn size="xs"
                    color="red"
                    @click="$emit('deleteQuestion', question)"
            >{{ $t("common.delete") }}</GrmBtn>
          </div>
        </div>
      </template>
      <div v-if="testbankObj.examType === 'QUIZ' || testbankExam.examType === 'QUIZ'" class="mt-2 flex flex-col gap-y-2">
          <div v-for="(answer, i) in question.answerList"
             :key="i"
             class="flex items-start gap-x-1">
          <GrmTextarea v-model="answer.answerText"
                       color="blue"
                       class="min-w-0 flex-1"
                       :disabled="!isCreate && !isCopy"
                       :placeholder="$t('exam.question.placeholder')"
          />
          <GrmBtn v-if="isCreate || isCopy"
                  size="xs"
                  color="red"
                  @click="onDeleteAnswer(answer)"
          >{{ $t("common.delete") }}</GrmBtn>
        </div>
        <div v-if="correct === 'wrong'"
             class="flex items-start"
        >
          <GrmTextarea disabled
                       value=""
                       color="red"
          />
        </div>
        <GrmBtn v-if="isCreate || isCopy" @click="onAddAnswer">{{ $t("testBank.add.answer") }}</GrmBtn>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmTextarea from "@/components/Common/textarea/GrmTextarea.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import {Device} from "@/utils";

export default {
  name: 'TestbankQuestionSubjective',
  components: {
    GrmBtn,
    GrmTextarea,
    GrmTextField,
  },
  props: {
    type: { type: String, default: 'view' },
    index: { type: Number, default: 0 },
    correct: { type: String, default: '' },
    question: { type: Object, default: () => ({}) },
    testbankObj: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapState('testbank', [
      'view',
      'testbankExam',
    ]),
    ...mapGetters('testbank', [
      'isCreate',
      'isEdit',
      'isCopy',
      'isView'
    ]),

    isMobile() {
      return Device.isMobile();
    }
  },
  methods: {
    onAddAnswer() {
      if (this.question.answerList.length === 10) {
        return;
      }

      this.question.answerList.push({
        answerText: '',
        correct: true,
        answerOrder: this.question.answerList.length,
      });
      this.question.correctAnswerCnt = this.question.answerList.length;
    },
    onDeleteAnswer(answer) {
      if (this.question.answerList.length === 1) {
        return;
      }

      const index = this.question.answerList.indexOf(answer);
      this.question.answerList.splice(index, 1);
      this.question.correctAnswerCnt = this.question.answerList.length;
    }
  }
}
</script>